import { camelToSnake, snakeToCamel } from "caseparser";

import { api } from "@/app/app.api";

import { RequestMethod } from "@/shared/utils/RequestMethod";

export const nutritionWizardApi = api
  .enhanceEndpoints({ addTagTypes: [] })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      finishNutritionWizard: builder.mutation({
        query: ({
          age,
          genre,
          height,
          weight,
          nutritionType,
          objective,
          nutritionId,
          userId,
          tableNutrition,
          cuisine,
        }) => ({
          url: `nutrition-wizard/finish`,
          method: RequestMethod.POST,
          body: camelToSnake({
            age,
            genre,
            height,
            heightUm: "cm",
            weight,
            weightUm: "cm",
            nutritionType,
            objective,
            nutritionId,
            userId,
            tableNutrition,
            cuisine,
          }),
        }),
        transformResponse: (response: any) => snakeToCamel(response.data),
      }),
      mealOptions: builder.query({
        query: ({ userId, kcal, cuisine, nutritionType, objective }) => ({
          url: `nutrition-wizard/meals`,
          method: RequestMethod.GET,
          params: camelToSnake({
            userId,
            cuisine,
            nutritionType,
            kcal,
            objective,
          }),
        }),
        transformResponse: (response: any) => snakeToCamel(response.data),
      }),
    }),
  });

export const {
  useFinishNutritionWizardMutation,
  useMealOptionsQuery,
  useLazyMealOptionsQuery,
} = nutritionWizardApi;
